import { routes } from './common';

export const redirectConfig = {
    [routes.NEW_SCOOTER]: routes.SCOOTERS,
    [routes.NEW_BIKE_OR_VAE]: routes.BIKES_AND_VAE,
};
